import * as $ from "jquery";

export const PostalPLRule = (() => {
	$.validator.addMethod("postalPL", function (value) {
		const PostalPLPattern: RegExp = /^[0-9]{2}-[0-9]{3}$/;

		return PostalPLPattern.test(value);
	}, $.validator.format("Kod pocztowy jest niepoprawny."));
})();import * as $ from "jquery";

export const PostalPLRule = (() => {
	$.validator.addMethod("postalPL", function (value) {
		const PostalPLPattern: RegExp = /^[0-9]{2}-[0-9]{3}$/;

		return PostalPLPattern.test(value);
	}, $.validator.format("Kod pocztowy jest niepoprawny."));
})();